import { useContext } from 'react';
import useStarRatings from '../useStarRatings';
import useEnabledFeature from '../../useEnabledFeature';
import ABSegmentContext from '../../../components/ab-segment-context';
import { BrandInfoContext } from '@core-ui/brand-info-provider';

const useRatingsFacet = (): boolean => {
  const { abbrBrand } = useContext(BrandInfoContext);
  const segments = useContext(ABSegmentContext);
  const ratingFacetSegmentEnabled = segments[`${abbrBrand}87`] === 'c';

  const featureEnabled = useEnabledFeature('cat-ratings-facet');

  const starRatingsEnabled = useStarRatings();

  return featureEnabled && starRatingsEnabled && ratingFacetSegmentEnabled;
};

export default useRatingsFacet;
